export const sortNewsByLatest = (newsArray) => {
  const compareByDate = (a, b) => {
    const dateA = a.post_date.split(" ")[0]; // Extract the date part
    const dateB = b.post_date.split(" ")[0]; // Extract the date part

    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;
    return 0;
  };

  newsArray.sort(compareByDate);

  return newsArray;
};
